import { render, staticRenderFns } from "./InternalMessage.vue?vue&type=template&id=47e8ce82&scoped=true"
import script from "./InternalMessage.vue?vue&type=script&lang=js"
export * from "./InternalMessage.vue?vue&type=script&lang=js"
import style0 from "./InternalMessage.vue?vue&type=style&index=0&id=47e8ce82&prod&lang=scss"
import style1 from "./InternalMessage.vue?vue&type=style&index=1&id=47e8ce82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8ce82",
  null
  
)

export default component.exports